import React from 'react'

const AppCard = ({ children }) => {
  return <div className='app-card form-card tabs-card max-width expand-on-small'>{children}</div>
}

export default AppCard
